import { lifecycle } from 'recompose';

import { tradeDeskConversion } from 'app/analytics/trackers/tradeDeskUP';

export default lifecycle({
  componentDidMount() {
    tradeDeskConversion();
  },
});
